import React, { useCallback } from 'react';
import { Typography } from '@mui/material';
import { Button } from '@ui/buttons';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(3),
    height: '100vh',
    backgroundColor: theme.palette.warmSurface.main,
  },
  message: {
    fontWeight: 400,
    color: 'rgba(0, 0, 0, 0.45)',
  },
}));

const FALLBACK_MESSAGE = 'Page not found';

export const NotFound: React.FC = () => {
  const { classes } = useStyles();
  const [searchParams] = useSearchParams();
  const message = searchParams.get('message') || FALLBACK_MESSAGE;
  const navigate = useNavigate();

  const navigateToHome = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return (
    <div className={classes.root}>
      <Typography className={classes.message} variant="h5">
        {message}
      </Typography>
      <Button variant="outlined" onClick={navigateToHome}>
        Reload application
      </Button>
    </div>
  );
};
